<template>
  <section class="flex flex-col bg-white">
    <div class="app-content relative flex-1 flex-shrink-0">
      <Transition
        name="fade-fastest"
        mode="out-in"
        appear
      >
        <RouterView />
      </Transition>
    </div>
    <AppFooter
      v-show="showFooter"
      class="flex-shrink-0"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import AppFooter from '@/components/app/AppFooter';

export default {
  components: {
    AppFooter,
  },
  computed: {
    ...mapState('user/events', {
      eventsLoadingStatus: 'loadingStatus',
    }),
    routeNeedsEventData() {
      return ['Dashboard', 'EventUpdate', 'EventDetails'].includes(this.$route.name);
    },
    showFooter() {
      return !(this.eventsLoadingStatus === 'init' && this.routeNeedsEventData) && !this.$route.meta.noFooter;
    },
  },
};
</script>

<style scoped>
</style>
